import { Injectable } from '@angular/core';
import { ApiService } from "../api/api.service";
import { Observable } from "rxjs";
import { AiListResponse } from "../../../concierge-app/chatbot/models/ai-list-response";
import { InteractionType } from "../../../concierge-app/chatbot/models/interaction-type";

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  constructor(private apiService: ApiService) {
  }

  postGetChat(message: string, userId: string): Observable<AiListResponse> {
    const payload = {chatMessage: message, userId};
    return this.apiService.postJson('/api/v3/reservations/chatbot/chat', null, payload);
  }

  postGetButtonInteract(interaction: InteractionType, userId: string, offset: number | null): Observable<AiListResponse> {
    const payload = {interaction, userId} as Record<string, any>;

    if (offset) {
      payload['popularOffset'] = offset;
    }

    return this.apiService.postJson('/api/v3/reservations/chatbot/button-interact', null, payload);
  }
}
